import type { ContentBuilder } from '../../ui/ContentBuilder';
import type { SettlementView } from '../utils';
import { getTreeAgeBars, getTreeTotal } from '../utils';
import type { HexMapState } from '../../../engine/render/renderer';
import { t } from '../../../i18n/translations';

export function renderForestTab(
    builder: ContentBuilder,
    state: HexMapState,
    settlement: SettlementView,
): void {
    const lang = state.config.ui.language;
    builder.section(t(lang, 'forest.section'), (section) => {
        section.text(t(lang, 'forest.treesTotal', getTreeTotal(settlement)));
    });
    builder.section(t(lang, 'forest.treesByAge'), (section) => {
        const bars = getTreeAgeBars(state, settlement);
        if (bars.length === 0) {
            section.text(t(lang, 'forest.noTrees'));
            return;
        }
        bars.forEach((bar) => section.bar(bar.label, bar.value, bar.max, bar.tone));
    });
}
